import {UseMutationResult, useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

interface GetCompletedPuzzlesPayload {
  meetingId: string;
  occurenceId: string;
}

export default function useGetCompletedPuzzlesApi(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: unknown) => void,
): UseMutationResult<any, unknown, GetCompletedPuzzlesPayload> {
  return useMutation<any, unknown, GetCompletedPuzzlesPayload>(
    async (payload: GetCompletedPuzzlesPayload) => {
      const response = await ChessRestClient.post(
        'classroom/v1/get_completed_puzzles/',
        payload,
      );
      console.log('get Completed Classroom Puzzles response ', response.data);
      return response.data;
    },
    {
      onSuccess: (data: any) => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        }
      },
      onError: (error: unknown) => {
        console.error('Failed to get Completed Classroom Puzzles :', error);
        if (handleOnError) {
          handleOnError(error);
        }
      },
    },
  );
}
